import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import {
  ADD_ORGANIZATION,
  GET_ORGANIZATION_DETAIL,
  ORGANIZATION_DETAIL_DELETE,
  ORGANIZATION_DETAIL_GET_COUNTRY,
  ORGANIZATION_DETAIL_GET_IP_LOCATION,
  ORGANIZATION_DETAIL_GET_LIST,
  ORGANIZATION_DETAIL_GET_STATE,
  UPDATE_ORGANIZATION_DETAIL
} from './actionTypes';
import {
  addOrganizationDetailFailed,
  addOrganizationDetailSuccess,
  getOrganizationDetailFailed,
  getOrganizationDetailSuccess,
  getOrganizationListError,
  getOrganizationListSuccess,
  organizationDetailGetIpBasedLocationError,
  organizationDetailGetIpBasedLocationSuccess,
  organizationDetailSetCountryError,
  organizationDetailSetCountrySuccess,
  organizationDetailSetStateError,
  organizationDetailSetStateSuccess,
  updateOrganizationDetailFailed,
  updateOrganizationDetailSuccess
} from './actions';


import {
  DELETEOrganization,
  PostOrganizationList,
  getAllCounties,
  getIpLocation,
  getStates,
  postAddOrganization, postGetOrganizationDetail, postUpdateOrganizationDetail
} from "../../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../../common/constant/constantURL";

//add organization
function* addOrganizations({payload:{organizationDetail}}) {
  try {
  
    var url=constClass.REST_API_RECRUITER_ADD_ORGANIZATION;
    const response = yield call(postAddOrganization, url, organizationDetail)
    yield put(addOrganizationDetailSuccess(response))
  }
  catch (error) {
    yield put(addOrganizationDetailFailed(error))
  }
}

//get organization detail
function* getOrganizationDetail({payload:{organizationDetail}}) {
  try {
  
    var url=constClass.REST_API_RECRUITER_GET_ORGANIZATION_DETAIL;
    const response = yield call(postGetOrganizationDetail, url, organizationDetail)
    
    yield put(getOrganizationDetailSuccess(response))
  }
  catch (error) {
    yield put(getOrganizationDetailFailed(error))
  }
}


//Update organization detail
function* updateOrganizationDetail({payload:{updateOrganizationDetail}}) {
  try {
    var url=constClass.REST_API_RECRUITER_UPDATE_ORGANIZATION_DETAIL;
    const response = yield call(postUpdateOrganizationDetail, url, updateOrganizationDetail)
    
    yield put(updateOrganizationDetailSuccess(response))
  }
  catch (error) {
    yield put(updateOrganizationDetailFailed(error))
  }
}

function* getCountries() {
  try {

    var url = constClass.REST_API_GET_COUNTRIES

    const response = yield call(getAllCounties, url)

    yield put(organizationDetailSetCountrySuccess(response))
   
  }
  catch (error) {
    yield put(organizationDetailSetCountryError(error))
  }
}

function* getState({ payload: { states } }) {
  try {
    var url = constClass.REST_API_GET_STATE

    const response = yield call(getStates, url, states)

    yield put(organizationDetailSetStateSuccess(response))

  }
  catch (error) {
    yield put(organizationDetailSetStateError(error))
  }
}

function* getIplocation() {
  try {
    var url = constClass.REST_API_GET_IP_LOCATION

    const response = yield call(getIpLocation, url)

    yield put(organizationDetailGetIpBasedLocationSuccess(response))

  }
  catch (error) {
    yield put(organizationDetailGetIpBasedLocationError(error))
  }
}
function* getOrganizationList({payload:{organizationDetail}}) {
  try 
  {
    var url = constClass.REST_API_RECRUITER_ORGANIZATION_LIST
    const response = yield call(PostOrganizationList, url,organizationDetail)
   
    yield put(getOrganizationListSuccess(response))
  }
  catch (error) {
    yield put(getOrganizationListError(error))
  }
}
function* deleteOrganization({payload:{organizationDetail}}) {
  try 
  {
    var data={}
    
    data.companyId=organizationDetail

   var url = constClass.REST_API_RECRUITER_ORGANIZATION_DELETE
     const response = yield call(DELETEOrganization, url,data)
   
     yield put(getOrganizationListSuccess(response))
  }
  catch (error) {
    yield put(getOrganizationListError(error))
  }
}


export function* watchRecruiterOrganization() {

  yield takeEvery(ADD_ORGANIZATION, addOrganizations)
  yield takeEvery(GET_ORGANIZATION_DETAIL, getOrganizationDetail)
  yield takeEvery(UPDATE_ORGANIZATION_DETAIL, updateOrganizationDetail)
  yield takeEvery(ORGANIZATION_DETAIL_GET_COUNTRY, getCountries)
  yield takeEvery(ORGANIZATION_DETAIL_GET_STATE, getState )
  yield takeEvery(ORGANIZATION_DETAIL_GET_IP_LOCATION, getIplocation )
  yield takeEvery(ORGANIZATION_DETAIL_GET_LIST, getOrganizationList )
  yield takeEvery(ORGANIZATION_DETAIL_DELETE, deleteOrganization )

}
function* RecruiterOrganizationSaga() {

  yield all([fork(watchRecruiterOrganization)])
}

export default RecruiterOrganizationSaga